import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Headings } from "../../../atoms/Headings";
import RequestWithdrawal from "../../../molecules/RequestWithdrawal";
import "./withdrawal.scss";
import { useLocation } from "react-router-dom";
const Withdrawal = (props) => {
  const location = useLocation();
  const { selectedPot } = location.state || {};
  return (
    <div className="request-withdrawal">
      <Container fluid>
        <Row>
          <Col lg={12} md={12}>
            <div className="lump-sums-heading">
              <Headings
                pageTitle={"Taking lump sums from drawdown"}
                bigTitle={true}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <RequestWithdrawal
            memberObj={props.memberObj}
            selectedPot={selectedPot}
          />
        </Row>
      </Container>
    </div>
  );
};

export default Withdrawal;
